import React from 'react';
import {useTranslation} from 'react-i18next';
import './Contact.css';
import facebookIcon from '../../../../assets/images/icons/facebookIcon.svg'
import telegramIcon from '../../../../assets/images/icons/telegramIcon.svg'
import whatsAppIcon from '../../../../assets/images/icons/whatsUpIcon.svg'
import instIcon from '../../../../assets/images/icons/instIcon.svg'
import meeticon from '../../../../assets/images/icons/meetIcon.svg'
import linkedInIcon from '../../../../assets/images/icons/linkedIn.svg'
import phoneIcon from '../../../../assets/images/icons/phoneIcon.svg'
import mailIcon from '../../../../assets/images/icons/mailIcon.svg'
import adressIcon from '../../../../assets/images/icons/adressIcon.svg'
import whyContactIcon1 from '../../../../assets/images/icons/whyContactIcon1.svg'
import whyContactIcon2 from '../../../../assets/images/icons/whyContactIcon2.svg'
import whyContactIcon3 from '../../../../assets/images/icons/whyContactIcon3.svg'
import whyContactIcon4 from '../../../../assets/images/icons/whyContactIcon4.svg'
import ContactFormWithBackground from '../../../../components/ContactFormWithBackgroundGray/ContactFormWithBackground';
import SEO from "../../../../utils/SEO";
import {COMPANY_ADDRESS} from "../../../../utils/companyAddress";
import {
    calendlyUrl,
    facebookUrl,
    instagramUrl,
    linkedinUrl,
    telegramUrl,
    whatsappUrl,
} from '../../../../components/Constant/socialLinks';

const Contact = () => {

    const {t} = useTranslation();
    const tp = (k, d) => t(`pages.contact.${k}`, d);

    const whyContactsArray = [
        {
            id: 1,
            point: "(01)",
            title: tp('why.items.0.title', 'Global Presence'),
            img: whyContactIcon1,
            descr: tp('why.items.0.descr', 'Offices in UK, Cyprus, and Albania.')
        },
        {
            id: 2,
            point: "(02)",
            title: tp('why.items.1.title', 'Expertise'),
            img: whyContactIcon2,
            descr: tp('why.items.1.descr', 'Specialized in licensing, offshore structures, and compliance.')
        },
        {
            id: 3,
            point: "(03)",
            title: tp('why.items.2.title', 'Proven Track Record'),
            img: whyContactIcon3,
            descr: tp('why.items.2.descr', 'Offices in UK, Cyprus, and Albania.')
        },
        {
            id: 4,
            point: "(04)",
            title: tp('why.items.3.title', 'Fast & Personalized Service'),
            img: whyContactIcon4,
            descr: tp('why.items.3.descr', 'Offices in UK, Cyprus, and Albania.')
        },
    ]

    

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/contact"
            />
            <div className='contact-us-background'>
            
                <div className='contact-us-container'>
                    <div className='contact-us-left'>
                        <h2 className='contact-us-title'>
                            {tp('title')}
                        </h2>
                        <div className='contact-us-social-row'>
                            <span className='contact-us-social-text'>
                                {tp('socialText')}
                            </span>
                              <a href={linkedinUrl}>
                                <img src={linkedInIcon} alt={tp('social.linkedin')} />
                            </a>
                            <a href={facebookUrl}>
                                <img src={facebookIcon} alt={tp('social.facebook')} />
                            </a>
                            <a href={calendlyUrl}>
                                <img src={meeticon} alt={tp('social.meet')} />
                            </a>
                            {/* <a>
                                <img src={skypeIcon} />
                            </a> */}
                            <a href={telegramUrl} >
                                <img src={telegramIcon} alt={tp('social.telegram')} />
                            </a>
                            <a href={whatsappUrl}>
                                <img src={whatsAppIcon} alt={tp('social.whatsapp')} />
                            </a>
                            <a href={instagramUrl}>
                                <img src={instIcon} alt={tp('social.instagram')} />
                            </a>
                        </div>
                    </div>
                    <div className='contact-us-right'>
                        <div className='contact-us-item'>
                            <span className='contact-us-item-key'>
                                {tp('info.phone')}
                            </span>
                            <div className='contact-us-item-row'>
                                <div className='contact-us-item-img'>
                                    <img src={phoneIcon} alt='Phone' />
                                    <a href='tel:+447385054407' >
                                        +447385054407
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className='contact-us-item'>
                            <span className='contact-us-item-key'>
                                {tp('info.email')}
                            </span>
                            <div className='contact-us-item-row'>
                                <div className='contact-us-item-img'>
                                    <img src={mailIcon} alt='Email' />
                                    
                                    
                                    <div>
                                        <a href='mailto:info@offshoreadvisory.pro'>info@offshoreadvisory.pro</a>
                                        <a href='tel:compliance@offshoreadvisory.pro'>compliance@offshoreadvisory.pro</a>
                                        <a href='tel:marketing@offshoreadvisory.pro'>marketing@offshoreadvisory.pro</a>
                                        <a href='tel:partnership@offshoreadvisory.pro'>partnership@offshoreadvisory.pro</a>
                                        <a href='tel:compliance@offshoreadvisory.pro'>citizenship@offshoreadvisory.pro</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='contact-us-item'>
                            <span className='contact-us-item-key'>
                                {tp('info.address')}
                            </span>
                            <div className='contact-us-item-row'>
                                <div className='contact-us-item-img'>
                                    <img src={adressIcon} alt='Address' />
                                    {COMPANY_ADDRESS}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='why-contact-container'>
                <div className='why-contact-left'>
                    <h2 className='why-contact-title'>
                        {tp('why.title')}
                    </h2>
                </div>
                <div className='why-contact-right'>
                    {whyContactsArray.map((item) => (
                        <div className='why-contact-item' key={item.id}>
                            <div className='why-contact-header-content'>
                                    <span className='why-contact-point'>
                                        {item.point}
                                    </span>
                                    <h2>
                                        {item.title}
                                    </h2>
                            </div>
                            <div className='why-contact-img-wrapper'>
                                        <img src={item.img} alt={item.title} />
                                    </div>
                                    <p className='why-contact-descr'>
                                        {item.descr}
                                    </p>
                        </div>
                    ))}
                    
                </div>
            </div>
            <ContactFormWithBackground />
            {/* <Footer /> */}
        </main>
    );
}

export default Contact;
